export default __webpack_public_path__ + "static/media/photo21.0a5db01e.jpg";